/// <reference path='../../_references.ts' />
module onvio.setup.activities {
    'use strict';

    export interface IActivityDetailStateParams extends ng.ui.IStateParamsService {
        id: string;
    }

    export interface IRelationshipVm {
        name: string;
        type: string;
        contact: cs.IContactV6Dto;
        data?: cs.IContactRelationshipV3Dto;
    }

    export interface IActivityDetailControllerScope extends bluemoon.ModalHelper.IModalScope {
        activityForm: ng.IFormController;
    }

    export interface IRootScopeIframe extends ng.IRootScopeService {
        $isOnIFrame: any;
        $parentEmit: any;
        $parentOn: any;
    }

    /* Model extending the dto */
    export interface IActivityModel extends cs.IActivityV1Dto {
        $activityType: cs.INamedReferenceDto;
        $class: cs.INamedReferenceDto;
        $rateType: cs.INamedReferenceDto;
        $surchargeMethod: cs.INamedReferenceDto;
    }

    export class ActivityDetailController extends bm.core.setup.common.CoreBaseDetailViewController<cs.IActivityV1Dto> {

        id: string;
        data: IActivityModel;

        //selectedStatus: string; // The UI is bound to this value
        surchargeMethodPerUnitReference: cs.INamedReferenceDto;

        detail: bmp.IDetailVm;

        isOnIframe: boolean;

        static $inject = [
            '$rootScope',
            '$window',
            '$scope',
            '$state',
            '$stateParams',
            '$q',
            '$translate',
            '$timeout',
            'bmpDetailVmFactory',
            'fef.Utils',
            'fef.PromiseUtils',
            'bmpErrorHandler',
            'bmpProviderUtils',
            'onvio.setup.activities.ActivityProvider',
            'bluemoon.components.Notifications',
            'resolve.translationsLoaded',
            'bmpFeatureToggles',
            'resolve.statusOptions',
            'resolve.typeOptions',
            'resolve.classOptions',
            'resolve.rateTypeOptions',
            'resolve.surchargeMethodOptions',
            'resolve.detailContext'
        ];

        constructor(
            protected $rootScope: IRootScopeIframe,
            protected $window: any,
            protected $scope: IActivityDetailControllerScope,
            protected $state: ng.ui.IStateService,
            protected $stateParams: IActivityDetailStateParams,
            private $q: ng.IQService,
            private $translate: ng.translate.ITranslateService,
            private $timeout: ng.ITimeoutService,
            private detailVmFactory: bmp.IDetailVmFactoryService,
            private utils: fef.IUtilsService,
            private promiseUtils: fef.IPromiseUtilsService,
            private errorHandler: bmp.IErrorHandlerService,
            private providerUtils: bmp.IProviderUtilsService,
            private activityProvider: onvio.setup.activities.IActivityProviderService,
            private notifications: bluemoon.components.INotificationsService,
            private translationsLoaded: any,
            private featureToggles: bmp.IFeatureTogglesService,
            public statusOptions: cs.INamedReferenceDto[],
            public typeOptions: cs.INamedReferenceDto[],
            public classOptions: cs.INamedReferenceDto[],
            public rateTypeOptions: cs.INamedReferenceDto[],
            public surchargeMethodOptions: cs.INamedReferenceDto[],
            public detailContext: any,
            public addOrEditHeader:boolean = false) {
                super('ClientDetailController', $scope, $state, $stateParams, detailContext, 'setup-activities-id', '/setup/activities', 'activityId', '');
            var self = this;
            featureToggles.isFeatureEnabledAsyncAndRedirect('OnvioSetup', 'Activities');

            this.id = this.bmpStateParamsId();

            // Keep a reference to the Per Unit surcharge method, because its display name changes based on the activityType
            this.surchargeMethodPerUnitReference = this.surchargeMethodOptions.filter(v => v.id === 'PERUNIT')[0];

            // Apply the DetailViewMixin to the this. This brings in all the shared functionality
            // for detail views.
            this.detail = detailVmFactory.create({
                formName: 'activityForm',
                id: this.id,
                backLink: this.defaultBackLinkFn(),
                loadDataPromise: () => this.loadDataPromise(),
                savePromise: () => this.savePromise(),
                canSave: () => this.canSave()
            }, $scope, this.inWorkspaceModal);

            this.detail.loadData();
            this.isOnIframe = $rootScope.$isOnIFrame();

            // Keep the name and invoice description in sync until the user changes the invoice description
            $scope.$watch('vm.data.name',
                (newValue: string, oldValue: string) => {
                    if (this.utils.exists(this.data) && this.data.invoiceDescription === oldValue) {
                        this.data.invoiceDescription = newValue;
                    }
                });

            //For implementation of Setup Assistant
            $rootScope.$parentOn('save-and-close', function(e: any, args: any) {
                self.detail.save();
            });

            $rootScope.$parentOn('cancel', function(e: any, args: any) {
                self.detail.cancel();
            });
            $rootScope.$on('$stateChangeSuccess', (ev, to, toParams, from, fromParams) => {
                var currentState = $state.current.name;
                var isactivities =  currentState == 'setup-activities-id';
                this.$rootScope.$parentEmit('changeModalAction', isactivities)
            });
        }

        savePromise() {
            return this.activityProvider.save(this.data).then(
                response => {
                    if (this.inWorkspaceModal) {
                        this.$scope.$modalUiView.modalStateData.stateParams[this.wsIdParamName] = response.id;
                        this.id = response.id;
                    }
                    return response;
                });
        }

        loadDataPromise(): ng.IPromise<cs.IActivityV1Dto> {
            if (this.detail.isNew) {
                return this.activityProvider.newActivity().then(data => {
                    data.id = this.providerUtils.newId();

                    //set search text when coming from workspaceModal
                    if (this.inWorkspaceModal) {
                        let searchText = this.workspaceSearchText;
                        if (searchText && !data.name) {
                            data.name = searchText;
                            this.workspaceSearchText = '';
                        }
                    }

                    this.data = this.initializeModel(data);
                    this.updateSurchargePerUnitMethodLabel();
                    this.detailContext.data = this.data;    // This is required to get core stuff to work
                    this.$rootScope.$parentEmit('changeModalTitle', this.activityLabel());
                    return data;
                });
            } else {
                return this.activityProvider.get(this.id).then(
                (data: cs.IActivityV1Dto) => {
                    this.data = this.initializeModel(data);
                    this.updateSurchargePerUnitMethodLabel();
                    this.$rootScope.$parentEmit('changeModalTitle', this.activityLabel());
                    return data;
                });
            }
        }

        canSave(): boolean {
            if (!this.utils.exists(this.data)) {
                return false;
            }
            return true;
        }

        activityLabel(): string {
            var label = '';
            if (this.utils.exists(this.data)) {
                if (!this.detail.isNew || this.utils.stringIsNonBlank(this.data.name)) {
                    var entityName = this.$translate.instant('Core.Captions.Activity.ClassOne');
                    label = this.$translate.instant('Bluemoon.Practice.Common.Titles.EntityDetailHeader',
                        {
                            entityName: entityName
                        }) + (this.data.name || this.$translate.instant('Bluemoon.Practice.Common.DefaultDisplayAs'));
                } else {
                    label = this.$translate.instant('Onvio.Setup.Activities.Detail.AddActivity');
                }
            }
            return label;

        }

        updateSurchargePerUnitMethodLabel() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.activityType)) {
                this.surchargeMethodPerUnitReference.name = this.data.activityType.id === 'TIME' ?
                    this.$translate.instant('Onvio.Setup.Activities.Detail.SurchargeMethodHourly') :
                    this.$translate.instant('Core.Enums.ActivitySurchargeMethod.PERUNIT');
                if (this.utils.exists(this.data.surchargeMethod) &&
                    this.data.surchargeMethod.id === this.surchargeMethodPerUnitReference.id) {
                    this.data.surchargeMethod.name = this.surchargeMethodPerUnitReference.name;
                }
            }
        }

        isExpense() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.activityType)) {
                return this.data.activityType.id === 'EXPENSE';
            }
            return false;
        }

        showSurchargeAndTaxCheckboxes(): boolean {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.class)) {
                return this.data.class.id === 'BILLABLE';
            }
            return false;
        }

        showAdminType(): boolean {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.class)) {
                return this.data.class.id === 'ADMINISTRATIVE';
            }
            return false;
        }

        onClassChanged() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.class)) {
                if (!this.showAdminType()) {
                    this.data.adminType = {
                        id: 'GENERAL',
                        name: this.$translate.instant('Core.Enums.ActivityAdministrativeType.GENERAL')
                    };
                }
                if (!this.showSurchargeAndTaxCheckboxes()) {
                    this.data.chargeSalesTax = false;
                    this.data.chargeServiceTax = false;
                    this.data.$surchargeMethod = {
                        id: 'NOSURCHARGE',
                        name: this.$translate.instant('Core.Enums.ActivitySurchargeMethod.NOSURCHARGE')
                    };
                }
            }
        }

        onActivityTypeChanged() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.activityType)) {
                this.updateSurchargePerUnitMethodLabel();
                if (this.data.surchargeMethod.id === 'PERUNIT') {
                    this.data.surchargeMethod = angular.copy(this.surchargeMethodPerUnitReference);
                }
                if (!this.showTimeRate()) {
                    if (this.utils.exists(this.data.adminType) && this.data.adminType.id === 'ACCRUABLEBENEFIT') {
                        this.data.adminType = {
                            id: 'GENERAL',
                            name: this.$translate.instant('Core.Enums.ActivityAdministrativeType.GENERAL')
                        };
                    }
                    this.data.$rateType = {
                        id: 'NORATE',
                        name: this.$translate.instant('Core.Enums.RateType.NORATE')
                    };
                } else if (!this.showExpenseRate()) {
                    this.data.unitPrice = '0';
                    this.data.unitCost = '0';
                }
            }
        }

        onRateTypeChanged() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.rateType)) {
                this.updateSurchargePerUnitMethodLabel();
                if (!this.showEmployeeRateDescription()) {
                    this.data.employeeRateDescription = null;
                }
                if (!this.showFixedRate()) {
                    this.data.unitPrice = '0';
                }
            }
        }

        onSurchargeMethodChanged() {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.surchargeMethod)) {
                if (this.data.surchargeMethod.id === 'NOSURCHARGE') {
                    this.data.surchargeAmount = null;
                    this.data.surchargePercent = null;
                } else if (this.data.surchargeMethod.id === 'PERCENT') {
                    this.data.surchargeAmount = null;
                    this.data.surchargePercent = '0';
                } else {
                    this.data.surchargeAmount = '0';
                    this.data.surchargePercent = null;
                }
            }
        }

        showTimeRate(): boolean {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.activityType)) {
                return this.data.activityType.id === 'TIME';
            }
            return false;
        }
        showExpenseRate(): boolean {
            return this.isExpense();
        }
        showSurchargeAmount(): boolean {
            if (this.showSurchargeAndTaxCheckboxes() && this.utils.exists(this.data) && this.utils.exists(this.data.surchargeMethod)) {
                return this.data.surchargeMethod.id === 'PERUNIT' || this.data.surchargeMethod.id === 'FIXEDAMOUNT';
            }
            return false;
        }
        showSurchargePercent(): boolean {
            if (this.showSurchargeAndTaxCheckboxes() && this.utils.exists(this.data) && this.utils.exists(this.data.surchargeMethod)) {
                return this.data.surchargeMethod.id === 'PERCENT';
            }
            return false;
        }
        showEmployeeRateDescription(): boolean {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.rateType)) {
                return this.data.rateType.id === 'EMPLOYEERATE';
            }
            return false;
        }
        showFixedRate(): boolean {
            if (this.utils.exists(this.data) && this.utils.exists(this.data.rateType)) {
                return this.data.rateType.id === 'FIXEDRATE';
            }
            return false;
        }

        public initializeModel(dto: cs.IActivityV1Dto): IActivityModel {
            var self = this;
            var isEqual = function(value1: cs.INamedReferenceDto, value2: cs.INamedReferenceDto) : boolean {
                if (self.utils.exists(value1) && self.utils.exists(value2)) {
                    return value1.id === value2.id;
                }
                return !self.utils.exists(value1) && !self.utils.exists(value2);
            };

            Object.defineProperty(dto, '$activityType', {
                get: function() {
                    return self.data.activityType;
                },
                set: function(value: cs.INamedReferenceDto) {
                    if (isEqual(self.data.activityType, value)) {
                        return;
                    }
                    self.data.activityType = value;
                    self.$timeout(() => { self.onActivityTypeChanged(); });
                }
            });
            Object.defineProperty(dto, '$class', {
                get: function() {
                    return self.data.class;
                },
                set: function(value: cs.INamedReferenceDto) {
                    if (isEqual(self.data.class, value)) {
                        return;
                    }
                    self.data.class = value;
                    self.$timeout(() => { self.onClassChanged(); });
                }
            });
            Object.defineProperty(dto, '$rateType', {
                get: function() {
                    return self.data.rateType;
                },
                set: function(value: cs.INamedReferenceDto) {
                    if (isEqual(self.data.rateType, value)) {
                        return;
                    }
                    self.data.rateType = value;
                    self.$timeout(() => { self.onRateTypeChanged(); });
                }
            });
            Object.defineProperty(dto, '$surchargeMethod', {
                get: function() {
                    return self.data.surchargeMethod;
                },
                set: function(value: cs.INamedReferenceDto) {
                    if (isEqual(self.data.surchargeMethod, value)) {
                        return;
                    }
                    self.data.surchargeMethod = value;
                    self.$timeout(() => { self.onSurchargeMethodChanged(); });
                }
            });
            return <IActivityModel>dto;
        }
    }

    angular.module('onvio.setup.activities.ActivityDetailController',
        [
            'ui.router',
            'ui.bootstrap.modal',
            'pascalprecht.translate',
            'bmpDetailVmFactory',
            'fef',
            'bmTranslateEventUtils',
            'bmpBigNumber',
            'bmpErrorHandler',
            'bmpProviderUtils',
            'onvio.setup.activities.ActivityProvider',
            'bluemoon.components.Notifications',
            'bmpClearValue',
            'bmpBigNumberRangeValidator'
        ])
        .controller('onvio.setup.activities.ActivityDetailController', ActivityDetailController)
        .config([
            '$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
                $stateProvider
                    .state('setup-activities-id', {
                        url: '/setup/activities/:id',
                        templateUrl: 'setup/src/activities/activity-detail.html',
                        controller: 'onvio.setup.activities.ActivityDetailController as vm',
                        resolve: {
                            'resolve.translationsLoaded': ['bmTranslateEventUtils',
                                (bmTranslateEventUtils: any) => {
                                    return bmTranslateEventUtils.loadEnd();
                                }],
                            'resolve.statusOptions': [
                                'onvio.setup.activities.ActivityProvider',
                                (activityProvider: onvio.setup.activities.IActivityProviderService) => {
                                    return activityProvider.getStatusOptionsAsync();
                                }
                            ],
                            'resolve.typeOptions': [
                                'onvio.setup.activities.ActivityProvider',
                                (activityProvider: onvio.setup.activities.IActivityProviderService) => {
                                    return activityProvider.getTypeOptionsAsync();
                                }
                            ],
                            'resolve.classOptions': [
                                'onvio.setup.activities.ActivityProvider',
                                (activityProvider: onvio.setup.activities.IActivityProviderService) => {
                                    return activityProvider.getClassOptionsAsync();
                                }
                            ],
                            'resolve.rateTypeOptions': [
                                'onvio.setup.activities.ActivityProvider',
                                (activityProvider: onvio.setup.activities.IActivityProviderService) => {
                                    return activityProvider.getRateTypeOptionsAsync();
                                }
                            ],
                            'resolve.surchargeMethodOptions': [
                                'onvio.setup.activities.ActivityProvider',
                                (activityProvider: onvio.setup.activities.IActivityProviderService) => {
                                    return activityProvider.getSurchargeMethodOptionsAsync();
                                }
                            ],
                            'resolve.detailContext': ['$stateParams', 'bmpDetailVmFactory',
                            ($stateParams: IActivityDetailStateParams, detailVmFactory: bmp.IDetailVmFactoryService) => {
                                var ret = detailVmFactory.createContext();
                                ret.id = $stateParams.id;
                                return ret;
                            }]
                        },
                    })
                    .state({
                        name: 'setup-activities-upgraded-id',
                        url: '/setup/activities/upgraded/:id',
                        template: '<app-activity-detail></app-activity-detail>',
                    });
            },
        ]).run(['$rootScope', '$window', ($rootScope: any, $window: any) => {
            if ($window.parent) {
                var parentAngular = $window.parent.angular;
                if (parentAngular) {
                    var iframeScope = parentAngular.element($window.frameElement).scope();

                    $rootScope.$isOnIFrame = function() {
                        return (iframeScope != undefined);
                    }

                    $rootScope.$parentEmit = function() {
                        if (iframeScope) {
                            //this screen is shown on an iframe and can comunicate with the parent
                            iframeScope.$emit.apply(iframeScope, arguments);
                            iframeScope.$applyAsync();
                        }
                    };

                    $rootScope.$parentOn = function(name: string, callback: any) {
                        if (iframeScope) {
                            if (iframeScope.$$listeners[name]) {
                                if (iframeScope.$$listeners[name].length != 0) {
                                    iframeScope.$$listeners[name] = null;
                                }
                            }
                                iframeScope.$on(name, function() {
                                    callback.apply(null, arguments);
                                    $rootScope.$applyAsync();
                                });

                        }
                    };
                }
            }
        }]);
;
}
